<template>
  <div :class="{ container: 1 }">
    <KeepAlive include="CompetitionCenter-PracticeAndExams">
      <router-view></router-view>
    </KeepAlive>
  </div>
</template>

<script>
export default {
  name: 'competitionCenter-container',
  // data: () => ({
  //   pad50: false,
  // }),
  data() {
    return {
      pad50: false,
      padTopnone: false,
    }
  },
  mounted() {
    document.getElementsByClassName('header-menu-container')[0].style.display =
      'none'
  },
  // beforeRouteUpdate(to, from) {
  //   console.log(to)
  //   this.pad50 = to.path.indexOf('/commonExam/') >= 0
  //   this.padTopnone = to.path.indexOf('/questionBankCenter/matchDetail/') >= 0
  // },
  // watch: {
  //   $route: {
  //     handler(val) {
  //       if (val) {
  //         console.log('val:', val)
  //         this.pad50 = val.path.indexOf('/commonExam/') >= 0
  //         this.padTopnone =
  //           val.path.indexOf('/questionBankCenter/matchDetail/') >= 0
  //         alert(this.pad50)
  //       }
  //     },
  //     deep: true,
  //   },
  // },
}
</script>

<style lang="scss" scoped>
.container {
  // background: #edf1f7;

  min-height: calc(100vh - 60px);
  background-color: #f7f8fa;
  height: auto;
  padding: 10px 40px;
}
</style>
<style lang="scss">
div {
  box-sizing: border-box;
}

.wg-table-operation {
  font-size: 12px !important;
  font-weight: 600;
}
</style>
